module.exports = __webpack_public_path__ + "static/bg01-611e06f48d355c02e97ee842fcf28976.png";